module.exports = __webpack_public_path__ + "img/no-video.8aab2b34.png";